import { dataMusic } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMusic = /*#__PURE__*/createIcon(dataMusic)
export default IconMusic
